import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-discrepancies',
  templateUrl: './discrepancies.component.html',
  styleUrl: './discrepancies.component.css'
})
export class DiscrepanciesComponent implements OnInit {

  discrepancies: any[] = [];
  isModalVisible = false;
  selectedOrder: any = null;
  isLoading = false;
  discrepancy_note = '';

  constructor(private dataService: DataserviceService, private message: NzMessageService) {}

  ngOnInit() {
    this.isLoading = true;
    this.data();
  }

  data() {
    this.dataService.getData('work-order/get-discrepancies').subscribe((res: any) => {
      if (res.result === 'success') {
        this.discrepancies = res.data;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.message.error('Failed to load discrepancies');
      }
    })
  }

  showResolveModal(order: any){
    this.selectedOrder = order;
    this.isModalVisible = true;
  }

  handleOk(){
    this.isLoading = true;
    this.selectedOrder.generic.discrepancy_review.discrepancy = 'complete';
    this.selectedOrder.generic.discrepancy_review.date_completed = new Date();
    this.selectedOrder.generic.discrepancy_review.result_notes = this.discrepancy_note;
    const obj = { id: this.selectedOrder.id, discrepancy_review: this.selectedOrder.generic.discrepancy_review };
    this.dataService.postData(obj, 'work-order/submit-discrepancy').subscribe((res: any) => {
      if (res.result === 'success') {
        this.message.success('Review has been completed');
        this.data();
        this.isModalVisible = false;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.message.error('Failed to complete review');
      }
    }), (error: any) => {
      this.isLoading = false;
      this.message.error('Failed to complete review');
    }
  }

  handleCancel(){
    this.isModalVisible = false;
    this.selectedOrder = null;
  }

  submit(){
    this.isLoading = true;
    this.selectedOrder.generic.discrepancy_review.submitted = true;
    this.selectedOrder.generic.discrepancy_review.submitted_date = new Date();
    const obj = { id: this.selectedOrder.id, discrepancy_review: this.selectedOrder.generic.discrepancy_review };
    this.dataService.postData(obj, 'work-order/submit-discrepancy').subscribe((res: any) => {
      if (res.result === 'success') {
        this.message.success('Review has been completed');
        this.data();
        this.isModalVisible = false;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.message.error('Failed to complete review');
      }
    }), (error: any) => {
      this.isLoading = false;
      this.message.error('Failed to complete review');
    }}

}
